import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { Dozvola } from '../lib/supabase';

interface Props {
  children: React.ReactNode;
  /** Dozvola koju stranica traži. Bez nje je dovoljna prijava. */
  trazi?: Dozvola;
}

/** Gdje korisnika poslati kad nema pristup traženoj stranici. */
export function pocetnaStranica(p: { moze_generisati?: boolean; moze_historija?: boolean;
                                     moze_postavke_uposlenika?: boolean;
                                     moze_korisnike?: boolean;
                                     moze_opste_postavke?: boolean } | null): string {
  if (!p) return '/login';
  if (p.moze_generisati)          return '/dashboard';
  if (p.moze_historija)           return '/historija';
  if (p.moze_postavke_uposlenika) return '/uposlenici';
  if (p.moze_korisnike)           return '/korisnici';
  if (p.moze_opste_postavke)      return '/postavke';
  return '/moj-obracun';
}

const Cekaj: React.FC<{ tekst: string }> = ({ tekst }) => (
  <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <p style={{ color: '#666' }}>{tekst}</p>
  </div>
);

const PrivateRoute: React.FC<Props> = ({ children, trazi }) => {
  const { user, profile, loading, profileMissing, moze } = useAuth();

  if (loading)  return <Cekaj tekst="Učitavanje..." />;
  if (!user)    return <Navigate to="/login" replace />;

  if (profileMissing) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#b91c1c' }}>
          Profil korisnika nije pronađen. Obratite se administratoru.
        </p>
      </div>
    );
  }

  if (!profile) return <Cekaj tekst="Učitavanje profila..." />;

  if (profile.aktivan === false) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#b91c1c' }}>
          Vaš nalog je deaktiviran. Obratite se direktoru.
        </p>
      </div>
    );
  }

  // Nema tražene dozvole — vodi ga na prvu stranicu koju smije vidjeti.
  if (trazi && !moze(trazi)) {
    const cilj = pocetnaStranica(profile);
    return <Navigate to={cilj} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
